import { render, staticRenderFns } from "./TopBoard.vue?vue&type=template&id=2098b15a&scoped=true&"
import script from "./TopBoard.vue?vue&type=script&lang=ts&"
export * from "./TopBoard.vue?vue&type=script&lang=ts&"
import style0 from "./TopBoard.vue?vue&type=style&index=0&id=2098b15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098b15a",
  null
  
)

export default component.exports